var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.422 7.12l-1.15 1.142c-.36.36-.557.838-.557 1.35 0 .51.197.99.557 1.349l13.032 13.031L14.257 37.04c-.359.359-.557.837-.557 1.349 0 .51.198.99.557 1.349l1.143 1.142a1.91 1.91 0 002.698 0l15.59-15.533c.359-.359.611-.837.611-1.353v-.006c0-.51-.253-.99-.611-1.348L18.14 7.119a1.927 1.927 0 00-1.363-.556c-.511 0-.997.197-1.356.557z"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
